import React from "react";

const RemoveAutoApproveBankCandidateFilledIcon = ({ cls }) => {
  return (
    <svg
      width="16"
      height="17"
      className={cls}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        d="M18,12c-3.309,0-6,2.691-6,6s2.691,6,6,6,6-2.691,6-6-2.691-6-6-6Zm4,6c0,.74-.216,1.424-.567,2.019l-5.452-5.453c.595-.351,1.279-.567,2.019-.567,2.206,0,4,1.794,4,4Zm-8,0c0-.74,.216-1.424,.567-2.019l5.452,5.453c-.595,.351-1.279,.567-2.019,.567-2.206,0-4-1.794-4-4ZM3,6C3,2.691,5.691,0,9,0s6,2.691,6,6-2.691,6-6,6S3,9.309,3,6ZM12.721,24H0v-5c0-2.761,2.239-5,5-5h6.079c-.682,1.178-1.079,2.541-1.079,4,0,2.393,1.056,4.534,2.721,6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RemoveAutoApproveBankCandidateFilledIcon;
